// Sentry initialization should be imported first!
import './instrument';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { store } from './store';
import App from './App';
import './index.css';

// Import our API utility to initialize interceptors
import './utils/api';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
      <ToastContainer position="top-right" autoClose={5000} />
    </Provider>
  </React.StrictMode>
);
